import React, { ReactElement } from 'react';

type Props = {
  height?: number | string;
  style?: React.CSSProperties;
  width?: number | string;
};

const Upload = (props: Props): ReactElement => {
  const { height, style, width } = props;

  return (
    <svg
      height={height}
      style={style}
      viewBox="0 0 48 48"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <g fill="currentColor" fillRule="nonzero">
          <path
            d="M40.875 31.174c.621 0 1.125.504 1.125 1.127v3.215c0 2.452-1.975 4.444-4.426 4.483L37.5 40h-27c-2.46 0-4.46-1.967-4.5-4.41V32.302c0-.623.504-1.127 1.125-1.127s1.125.504 1.125 1.127v3.206c0 1.218.977 2.209 2.193 2.239H37.5c1.224 0 2.219-.971 2.25-2.182v-3.263c0-.608.48-1.104 1.083-1.126l.042-.001zM23.8 34.168c.622 0 1.125-.505 1.125-1.127V13.847l4.444 4.45c.43.43 1.12.44 1.56.03l.03-.03c.43-.43.44-1.12.03-1.563l-.03-.03-6.363-6.374c-.43-.43-1.12-.44-1.56-.03l-.031.03-6.364 6.374c-.44.44-.44 1.153 0 1.593.43.43 1.12.44 1.56.03l.031-.03 4.443-4.45v19.194c0 .622.504 1.127 1.125 1.127z"
            transform="translate(-413 -458) translate(365 357) translate(0 67) translate(48 34)"
          />
        </g>
      </g>
    </svg>
  );
};

Upload.defaultProps = {
  width: '100%',
  height: '100%',
};

export default Upload;
